<template>
  <section class="document-edit">
    <header>
      <mo-pageheader>
        <template slot="title">{{ $t('title.param') }}</template>
        <template slot="action">
          <div class="buttons-container flex flex-end">
            <ba-button type="button" class="primary" @click.native="$router.go(-1)">{{ $t('action.return') }}</ba-button>
            <ba-button class="primary" @click.native="handleUpdateAdherent" >{{ $t('action.save') }}</ba-button>
          </div>
        </template>
      </mo-pageheader>
    </header>

    <!-- TABS -->
        <div class="tabs-ctn flex flex-center tabs-margin">
          <div class="tab active" v-if="accessAdherent"
            @click="clickOnglet(1)"
            >{{ $t('sectionTitle.adherents') }}
          </div>
          <div class="tab" v-if="accessCompany"
            @click="clickOnglet(2)"
            >{{ $t('sectionTitle.compagnies') }}
          </div>
          <div class="tab" v-if="accessUser"
            @click="clickOnglet(3)"
            >{{ $t('sectionTitle.utilisateurs') }}
          </div>
          <div class="tab" v-if="accessDroits"
            @click="clickOnglet(4)"
            >{{ $t('sectionTitle.droits') }}
          </div>
        </div>
    <main>

        <ba-card>
          <template slot="header">
            <span>{{ $t('sectionTitle.compteadherent') }}</span>
          </template>
          <template>
            <div class="cols">
              <div class="col-3">
                <ba-input type="text" label="Raison sociale" v-model="adherent.name" ></ba-input>
              </div>
              <div class="col-3">
                <ba-input type="text" label="Adresse" v-model="adherent.address"></ba-input>
              </div>
              <div class="col-3">
                <ba-input type="text" label="Code postal" v-model="adherent.zip_code"></ba-input>
              </div>
              <div class="col-3">
                <ba-input type="text" label="Ville" v-model="adherent.city"></ba-input>
              </div> 
              <div class="col-3">
                <ba-input type="text" label="Contact" v-model="adherent.contact"></ba-input>
              </div>
              <div class="col-3">
                <ba-input type="text" label="Téléphone" v-model="adherent.phone"></ba-input>
              </div>
              <div class="col-3">              
                <ba-input type="text" label="Email" v-model="adherent.email"></ba-input>
              </div>

              <!-- Drag & drop section -->
              <div class="col-3 height-filepond" style="display:flex">
                <form @submit.prevent="uploadFile" enctype="multipart/form-data" >
                  <file-pond
                    name="pond"
                    ref="pond"
                    style="background: #fff; width: 300px"
                    :label-idle="attachedFile.pondLabel"
                    :allow-multiple="false"
                    :max-file-size="attachedFile.maxFileSizeTrunc"
                    :label-file-type-not-allowed="'Fichier invalide'"
                    :file-validate-type-label-expected-types="''"
                    :label-max-file-size-exceeded="'Le fichier est trop lourd'"
                    :label-max-file-size="`La taille d'un fichier doit être de ${attachedFile.maxFileSizeTrunc} maximum`"
                    :allow-file-type-validation="true"
                    :accepted-file-types="attachedFile.pondAcceptedFileType">
                  </file-pond>
                </form>
                <div class="filepond--img">
                  <img :src="handleGetAdherentImage(adherent.logo_path)" @error='defaultImage' v-if="adherent.logo_path != null" />   
                </div>
              </div>
            </div>
          </template>
        </ba-card>

        <!-- Buttons section -->
        <div class="buttons-container flex flex-end button-end">
          <ba-button class="primary" @click.native="handleUpdateAdherent">{{ $t('action.save') }}</ba-button>
        </div>
    </main>
  </section>
</template>

<script>
import { AbIcon, BaButton, BaCard, BaCheckbox, BaDropdownInput, BaInput, BaSelect, BaTextarea } from '@ab/basic-components';
import MoPageheader from '@/components/layout/nav/mo-pageheader.vue';

import { mapState } from 'vuex';

import vueFilePond from 'vue-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

const FilePond = vueFilePond(FilePondPluginFileValidateSize, FilePondPluginFileValidateType);

export default {
  name: 'AdherentCreate',
  components: {
    AbIcon,
    BaButton,
    BaCard,
    BaCheckbox,
    BaDropdownInput,
    BaInput,
    BaSelect,
    BaTextarea,
    MoPageheader,
    FilePond
  },
  async mounted() {

    this.accessAdherent = await this.$store.dispatch('getAccesRole', {search:29,role:this.$store.state.authentication.user.Role.id,data:this.$store.state.authentication.user.allDetailRole}); 

    this.accessCompany = await this.$store.dispatch('getAccesRole', {search:30,role:this.$store.state.authentication.user.Role.id,data:this.$store.state.authentication.user.allDetailRole}); 

    this.accessUser = await this.$store.dispatch('getAccesRole', {search:31,role:this.$store.state.authentication.user.Role.id,data:this.$store.state.authentication.user.allDetailRole}); 

    this.accessDroits = await this.$store.dispatch('getAccesRole', {search:32,role:this.$store.state.authentication.user.Role.id,data:this.$store.state.authentication.user.allDetailRole});     

    const id = this.$route.params.id;
    if(id != null) {
      this.adherent = await this.$store.dispatch('getParamAdherents',{ id: id });
      if (this.adherent.id == '') {
        this.$store.dispatch('displaySnackbar', { text: `L'adhérent n'a pas été trouvé`, mode: 'error' });
        return this.$router.go(-1);
      }  
    }
    this.$store.commit('setSpinner', false);
  },
  data() {
    return {
      accessAdherent: false,
      accessCompany: false,
      accessUser: false,
      accessDroits: false,
      adherent: {
        id: '',      
        name: '',
        address: '',
        zip_code: '',
        city: '',
        email: '',
        contact: '',
        phone: '',
      },
      attachedFile: '',
      fileStatus: '',
      files: '',
      attachedFile: {
        fileId: null,
        fileStatus: '',
        maxFileSize: 10000000,
        maxFileSizeTrunc: '10 MB',
        pondLabel: "Glissez votre fichier ou <u>cliquez ici</u> format JPG, PNG, GIF",
        pondAcceptedFileType: ['image/jpeg', 'image/png', 'image/gif'],
        currentPage: 1,
        searchLimit: 5,
        resultatImport:null
      },
      isDuplicationOngoing: false,
      isUpdateOngoing: false,
    }
  },
  methods: {
    clickOnglet(x) {
      switch (x) {
        case 1:
          this.$router.push('/param/adherents')
          break;
        case 2:
          this.$router.push('/param/companies')
          break;
        case 3:
          this.$router.push('/param/users')
          break;
        case 4:
          this.$router.push('/param/droits')
          break;                    
        case 5:
          this.$router.push('/param/consignes');
          break;
        default:
      }
    },
    // Handle modal
    beforeOpen(e) {
      this.removeModal.id = e.params.id;
      this.removeModal.label = e.params.label;
      this.removeModal.type = e.params.type;
    },
    closeModal() {
      this.removeModal.id = '';
      this.removeModal.type = '';
      this.$modal.hide('remove-cnit-mine');
    },
    async handleUpdateAdherent(redirect = true) {
      if(this.adherent.name.trim() == '') {
        return this.$store.dispatch('displaySnackbar', { text: `Veuillez renseigner La raison sociale`, mode: 'error' });        
      }

      this.$store.dispatch('setLoading', true);

      if(this.$route.params.id == '' || this.$route.params.id == null) {
          let formData = new FormData();
            if(this.$refs.pond.getFile() !=  null) {
              if (this.$refs.pond.getFile().fileSize > this.attachedFile.maxFileSize) {
                return this.$store.dispatch('displaySnackbar', { text: `Veuillez ajouter une image dont la taille de dépasse pas ${this.attachedFile.maxFileSizeTrunc}`, mode: 'error' });
              }

              // Check file type
              const fileType = this.attachedFile.pondAcceptedFileType.find(e => e == this.$refs.pond.getFile().file.type);
              if (typeof fileType == 'undefined') {
                return this.$store.dispatch('displaySnackbar', { text: `Veuillez sélectionner une image ayant un format valide`, mode: 'error' });
              }

              let file = this.$refs.pond.getFile().file;
              formData.append('fileUpload', file, file.name);
            }

        const data = await this.$store.dispatch('createParamAdherent', {
            name: this.adherent.name == '' ? ' ' : this.adherent.name,
            address: this.adherent.address == '' ? ' ' : this.adherent.address,
            zip_code: this.adherent.zip_code == '' ? ' ' : this.adherent.zip_code,
            city: this.adherent.city == '' ? ' ' : this.adherent.city,
            email: this.adherent.email == '' ? ' ' : this.adherent.email,
            contact: this.adherent.contact == '' ? ' ' : this.adherent.contact,
            phone: this.adherent.phone == '' ? ' ' : this.adherent.phone,      
            data: formData,
        });
        if (data) {
          this.$store.dispatch('displaySnackbar', { text: "L'adhérent à bien été enregistré" });
          this.$store.commit('setSpinner', false);
          if (redirect) this.$router.go(-1);
        }  
      } else {
          // Check file size
          let formData = new FormData();
            if(this.$refs.pond.getFile() !=  null) {
              if (this.$refs.pond.getFile().fileSize > this.attachedFile.maxFileSize) {
                return this.$store.dispatch('displaySnackbar', { text: `Veuillez ajouter une image dont la taille de dépasse pas ${this.attachedFile.maxFileSizeTrunc}`, mode: 'error' });
              }

              // Check file type
              const fileType = this.attachedFile.pondAcceptedFileType.find(e => e == this.$refs.pond.getFile().file.type);
              if (typeof fileType == 'undefined') {
                return this.$store.dispatch('displaySnackbar', { text: `Veuillez sélectionner une image ayant un format valide`, mode: 'error' });
              }

              let file = this.$refs.pond.getFile().file;
              formData.append('fileUpload', file, file.name);
            }

          // Prevent from clicking on button during operation
          const data = await this.$store.dispatch('updateParamAdherent', {
            id: this.adherent.id == '' ? ' ' : this.adherent.id,
            name: this.adherent.name == '' ? ' ' : this.adherent.name,
            address: this.adherent.address == '' ? ' ' : this.adherent.address,
            zip_code: this.adherent.zip_code == '' ? ' ' : this.adherent.zip_code,
            city: this.adherent.city == '' ? ' ' : this.adherent.city,
            email: this.adherent.email == '' ? ' ' : this.adherent.email,
            contact: this.adherent.contact == '' ? ' ' : this.adherent.contact,
            phone: this.adherent.phone == '' ? ' ' : this.adherent.phone,      
            data: formData,
          });

          if (data) {
            this.$store.dispatch('displaySnackbar', { text: "L'adhérent à bien été enregistré" });
            this.$store.commit('setSpinner', false);          
            if (redirect) this.$router.go(-1);
          }  
      }  
      this.$store.commit('setSpinner', false);
    },
    /* Get adherent image */
    handleGetAdherentImage(img) {
      const baseApi = process.env.VUE_APP_ROOT_API;
      return `${baseApi}/upload/adherent/${img}`;
    },    
    /* Image for error case */
    defaultImage(e) {
      e.target.src = 'https://cdn.activcar.fr/media/64/brands/default.png';
    },
  }
}
</script>
<style scoped>
.tabs-margin {
  margin-bottom: 2rem;
}

.filepond--wrapper {
  margin: 0;
  margin-bottom: 2rem;
}

form > .ba-card {
  margin-bottom: 1rem;
}

.button-end {
  margin-top: 2rem;
}

.height-filepond {
  display:flex;
}

.height-filepond form {
  margin-right: 20px;
  width: 65%;
}

.filepond--img {
  width: calc(35% - 20px);
}

.filepond--img img {
    max-width: 100%;
    height: auto;
    max-height: 66px;
}
</style>
<style src="@/assets/styles/documents.css"></style>
<style src="@/assets/styles/datepickers.css"></style>
<style src="@/assets/styles/modals.css"></style>
<style src="@/assets/styles/filepond.css"></style>
<style src="@/assets/styles/tabs.css"></style>
